// 轻量 Toast：已下沉 web/shared/components/Toast（FE-E3b 注入式，card 风格）；
// 本壳注入 admin 现值（error 7000ms / z-[200] / max-w-[440px] / error 红边卡片 + role=alert），
// 渲染输出与原实现逐字等价；73 处 '@/components/Toast' import 路径与调用点零改动。
import type { ReactNode } from 'react';
import { ToastProvider as SharedToastProvider, useToast } from '@shared/components/Toast';

export { useToast };

// 审查 I2：durations 提为模块级常量——内联对象会使 push/api 引用随 App 根重渲染变化，
// 触发依赖 toast 的 useEffect 重跑（多余请求）；常量引用恒稳定。
const TOAST_DURATIONS = { success: 3200, error: 7000, info: 3200 } as const;

export function ToastProvider({ children }: { children: ReactNode }) {
  return (
    <SharedToastProvider
      durations={TOAST_DURATIONS}
      zIndexClass="z-[200]"
      maxWidthClass="max-w-[440px]"
      itemExtraClass="pointer-events-auto shadow-lg"
      errorItemClass="border border-red-200 bg-red-50/95"
      errorRoleAlert
    >
      {children}
    </SharedToastProvider>
  );
}
